
<span :aria-hidden="!title"
      :aria-label="title"
      class="material-design-icon close-icon"
      role="img"
      v-bind="$attrs"
      @click="$emit('click', $event)">
  <svg :fill="fillColor"
       class="material-design-icon__svg"
       :width="size"
       :height="size"
       viewBox="0 0 24 24">
    <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z">
      <title v-if="title">{{ title }}</title>
    </path>
  </svg>
</span>
